import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FaBookOpen, FaCheckCircle, FaGraduationCap } from 'react-icons/fa';
import {
  createPublicEducationRegistration,
  getPublicEducationFacilities
} from '../../../api/sportsAppointmentService';

const PublicEducationRegistrationForm = () => {
  const [facilities, setFacilities] = useState([]);
  const [selectedFacilityId, setSelectedFacilityId] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    identityNumber: '',
    gender: '',
    birthDate: '',
    phone: '',
    email: '',
    address: '',

  });

  const selectedFacility = useMemo(
    () => facilities.find((facility) => String(facility.facilityId) === String(selectedFacilityId)) || null,
    [facilities, selectedFacilityId]
  );

  const fetchFacilities = useCallback(async () => {
    const response = await getPublicEducationFacilities();
    if (response.isSuccess) {
      setFacilities(response.data || []);
    }
  }, []);

  useEffect(() => {
    fetchFacilities();
  }, [fetchFacilities]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!formData.firstName || !formData.lastName || !formData.identityNumber || !formData.gender || !formData.birthDate || !formData.phone || !formData.email) {
      setError('Lutfen zorunlu alanlari doldurunuz.');
      return;
    }

    const payload = {
      facilityId: selectedFacilityId ? Number(selectedFacilityId) : null,
      courseScheduleId: null,
      sportTypeId: null,
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      identityNumber: formData.identityNumber.trim(),
      gender: formData.gender,
      birthDate: formData.birthDate,
      phone: formData.phone.trim(),
      email: formData.email.trim(),
      address: formData.address.trim() || null,
      preferredDate: null,
      preferredStartHour: null,
      preferredEndHour: null,
      notes: null
    };

    setSubmitting(true);
    try {
      const response = await createPublicEducationRegistration(payload);
      if (response.isSuccess) {
        setSuccessMessage('Basvurunuz alinmistir. Halk Egitim panelinde gorunecektir.');
        setFormData({
          firstName: '',
          lastName: '',
          identityNumber: '',
          gender: '',
          birthDate: '',
          phone: '',
          email: '',
          address: '',

        });
      } else {
        setError(response.resultMessage || 'Basvuru kaydedilemedi.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="sa-panel-inner sa-panel-inner--wide">
      <div className="sa-facility-details">
        <div className="sa-facility-details-header">
          <div className="sa-facility-title">
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaGraduationCap />
              Halk Egitim Kayit Formu
            </h3>
            <span className="sa-facility-region">
              Lutfen basvuru yapmak istediginiz tesisi secip bilgilerinizi giriniz.
            </span>
          </div>
        </div>

        <form className="sa-appointment-section" onSubmit={handleSubmit}>
          <div className="sa-booking-form" style={{ marginTop: 0 }}>
            <div className="sa-form-grid">
              <div className="sa-form-group">
                <label>Tesis <span className="sa-required">*</span></label>
                <select
                  className="sa-form-input"
                  value={selectedFacilityId}
                  onChange={(event) => setSelectedFacilityId(event.target.value)}
                  required
                >
                  <option value="">Tesis seciniz</option>
                  {facilities.map((facility) => (
                    <option key={facility.facilityId} value={facility.facilityId}>
                      {facility.facilityName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="sa-booking-form">
            <h4>Kisisel Bilgiler</h4>
            <div className="sa-form-grid">
              <div className="sa-form-group">
                <label>Ad <span className="sa-required">*</span></label>
                <input className="sa-form-input" value={formData.firstName} onChange={(event) => setFormData({ ...formData, firstName: event.target.value })} required />
              </div>
              <div className="sa-form-group">
                <label>Soyad <span className="sa-required">*</span></label>
                <input className="sa-form-input" value={formData.lastName} onChange={(event) => setFormData({ ...formData, lastName: event.target.value })} required />
              </div>
              <div className="sa-form-group">
                <label>TC Kimlik No <span className="sa-required">*</span></label>
                <input
                  className="sa-form-input"
                  value={formData.identityNumber}
                  maxLength={11}
                  onChange={(event) => {
                    const value = event.target.value.replace(/\D/g, '');
                    if (value.length <= 11) setFormData({ ...formData, identityNumber: value });
                  }}
                  required
                />
              </div>
              <div className="sa-form-group">
                <label>Cinsiyet <span className="sa-required">*</span></label>
                <select className="sa-form-input" value={formData.gender} onChange={(event) => setFormData({ ...formData, gender: event.target.value })} required>
                  <option value="">Seciniz</option>
                  <option value="Kadin">Kadin</option>
                  <option value="Erkek">Erkek</option>
                  <option value="Diger">Diger</option>
                </select>
              </div>
              <div className="sa-form-group">
                <label>Dogum Tarihi <span className="sa-required">*</span></label>
                <input className="sa-form-input" type="date" value={formData.birthDate} onChange={(event) => setFormData({ ...formData, birthDate: event.target.value })} required />
              </div>
              <div className="sa-form-group">
                <label>Telefon <span className="sa-required">*</span></label>
                <input className="sa-form-input" value={formData.phone} onChange={(event) => setFormData({ ...formData, phone: event.target.value })} required />
              </div>
              <div className="sa-form-group">
                <label>E-posta <span className="sa-required">*</span></label>
                <input className="sa-form-input" type="email" value={formData.email} onChange={(event) => setFormData({ ...formData, email: event.target.value })} required />
              </div>
              <div className="sa-form-group">
                <label>Adres</label>
                <input className="sa-form-input" value={formData.address} onChange={(event) => setFormData({ ...formData, address: event.target.value })} />
              </div>
            </div>



            {error && (
              <div style={{ color: '#b91c1c', background: '#fee2e2', border: '1px solid #fecaca', padding: '12px 14px', borderRadius: '10px', marginTop: '14px' }}>
                {error}
              </div>
            )}
            {successMessage && (
              <div style={{ color: '#065f46', background: '#ecfdf5', border: '1px solid #a7f3d0', padding: '12px 14px', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '14px' }}>
                <FaCheckCircle />
                {successMessage}
              </div>
            )}

            <div className="sa-action-row">
              <button type="submit" className="sa-submit-button" disabled={submitting}>
                <FaBookOpen />
                {submitting ? 'Gonderiliyor...' : 'Halk Egitim Basvurusu Gonder'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PublicEducationRegistrationForm;
